module.exports = __webpack_public_path__ + "assets/icon-feeling-positive-component.7f270ba8.svg";